import { ActivityIndicator, StyleSheet, View } from 'react-native'
import { Button } from '../../../../components/Button'
import { toqueColor, white } from '../../../../theme/colors'
import { DeleteIcon, SendIcon } from '../../../../components/Svg'

interface Props {
  onDelete: () => void
  onSend: () => void
  isLoading: boolean
}

export const ActionsButtons = ({ isLoading, onDelete, onSend }: Props) => {
  return (
    <View style={styles.container}>
      <Button
        label='Eliminar'
        onPress={onDelete}
        variant='white'
        children={<DeleteIcon height={16} width={17} />}
      />
      <Button
        label='Enviar'
        onPress={onSend}
        customStyle={styles.sendBtn}
        children={isLoading ? <ActivityIndicator /> : <SendIcon height={16} width={17} />}
        disabled={isLoading}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: { flexDirection: 'row', paddingBottom: 8, justifyContent: 'center', gap: 24 },
  deleteBtn: {
    backgroundColor: white,
    borderColor: toqueColor,
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    justifyContent: 'center',
    marginLeft: 0,
    marginRight: 0,
  },

  sendBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    justifyContent: 'center',
    marginLeft: 0,
    marginRight: 0,
  },
})
